import {
  FETCH_EXPENSES_REQUEST,
  FETCH_EXPENSES_SUCCESS,
  FETCH_EXPENSES_FAILURE,
  CREATE_EXPENSE_REQUEST,
  CREATE_EXPENSE_SUCCESS,
  CREATE_EXPENSE_FAILURE,
  UPDATE_EXPENSE_REQUEST,
  UPDATE_EXPENSE_SUCCESS,
  UPDATE_EXPENSE_FAILURE,
  DELETE_EXPENSE_REQUEST,
  DELETE_EXPENSE_SUCCESS,
  DELETE_EXPENSE_FAILURE,
} from "./expensesActionTypes";
const initialState = {
  data: [],
  loading: false,
  error: null,
};
const expensesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EXPENSES_REQUEST:
      return { ...state, loading: true, error: null };
   case FETCH_EXPENSES_SUCCESS:
  console.log('FETCH_EXPENSES_SUCCESS:', action.payload);
  return { ...state, loading: false, error: null, data: action.payload };

    case FETCH_EXPENSES_FAILURE:
      return { ...state, loading: false, error: action.payload, data: [] };
    case CREATE_EXPENSE_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_EXPENSE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case CREATE_EXPENSE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_EXPENSE_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_EXPENSE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case UPDATE_EXPENSE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_EXPENSE_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_EXPENSE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case DELETE_EXPENSE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export default expensesReducer;
